import toggleScroll from '../utils/toggleScroll';

export default () => {
  const $menu = $('.popup-menu__list');
  const $header = $('.header-page');

  $menu.on('click', '.popup-menu__link', (e) => {
    e.preventDefault();
    const $link = $(e.currentTarget);
    const sectionTarget = $link.attr('href');

    if (sectionTarget === 'top') {
      return;
    }

    const $sectionTarget = $(`${sectionTarget}`);
    if (!$sectionTarget.length) {
      return;
    }

    const sectionOffsetTop = $sectionTarget.offset().top - $header.height();

    const $body = $('html, body');
    toggleScroll();
    $('.popup--active').removeClass('popup--active');
    $body.scrollTop(sectionOffsetTop);
  });
};
